<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
      <i class="el-icon-menu"></i>
    </div>
    <div class="logo">基于物联网的人防警报管理平台</div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 全屏显示 -->
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <!-- 消息中心 -->
        <!--<div class="btn-bell">-->
        <!--<el-tooltip effect="dark" :content="message?`有${message}条未读消息`:`消息中心`" placement="bottom">-->
        <!--<router-link to="/tabs">-->
        <!--<i class="el-icon-bell"></i>-->
        <!--</router-link>-->
        <!--</el-tooltip>-->
        <!--<span class="btn-bell-badge" v-if="message"></span>-->
        <!--</div>-->
        <!-- 用户头像 -->
        <div class="user-avator">
          <!--<img src="../../assets/img/img.jpg">-->
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{username}} <i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item divided  @click.native="gotoDataBaseBackup">备份还原</el-dropdown-item>-->
            <el-dropdown-item divided  @click.native="showUpdatePasswordDialog">修改密码</el-dropdown-item>
            <el-dropdown-item divided  @click.native="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog :visible.sync="updatePasswordDialogVisible" @close="updatePasswordDialogVisible = false" title="修改密码">
      <el-form :label-position="labelPosition" label-width="80px"  :ref="UpdatePasswordBySelf.params" :model="UpdatePasswordBySelf.params" :rules="rulesOfUpdatePassword">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="UpdatePasswordBySelf.params.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="UpdatePasswordBySelf.params.newPassword"></el-input>
        </el-form-item>
        <!--<el-form-item label="台站类型">-->
        <!--<el-input v-model="AddAlarmPoint.params.alarmPointType"></el-input>-->
        <!--</el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkUpdatePassword">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from './bus';
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 20){
        callback(new Error('密码必须由6 - 20 个字符组成'))
      } else {
        callback();
      }
    };
    return {
      rulesOfUpdatePassword:{
        oldPassword: [
          { validator: validatePass2, trigger: 'change' }
        ],
        newPassword: [
          { validator: validatePass2, trigger: 'change' }
        ],
      },
      labelPosition:'left',
      updatePasswordDialogVisible:false,
      collapse: false,
      fullscreen: false,
      name: 'admin',
      message: 2,
      // 注销
      Logout:{
        "version": 1,
        "method": "user.Logout",
        "params": null,
        "token": "#",
        "id": 0
      },
      // 修改密码
      UpdatePassword:{
        "version": 1,
        "method": "user.UpdatePassword",
        "params": {
          "userId": "",
          "newPassword": ""
        },
        "token": "#",
        "id": 0
      },
      UpdatePasswordBySelf:{
        "version": 1,
        "method": "user.UpdatePasswordBySelf",
        "params": {
          "oldPassword": "",
          "newPassword":""
        },
        "token": "#",
        "id": 0
      }
    }
  },
  computed:{
    username(){
      // let username = localStorage.getItem('ms_username');
      let username = this.$store.state.userInfo.username;
      return username ? username : this.name;
    }
  },
  methods:{
    showUpdatePasswordDialog(){
      this.updatePasswordDialogVisible = true;
    },
    checkUpdatePassword(){
      this.$refs[this.UpdatePasswordBySelf.params].validate((valid) => {
        if (valid) {
          this.updatePassword();
        } else {
          this.$message({
            type: 'error',
            message: '参数不合理，拒绝修改'
          })
          return false;
        }
      });
    },
    updatePassword(){
      this.UpdatePasswordBySelf.token = this.$store.state.token;
      console.log('更改密码请求');
      console.log(this.UpdatePasswordBySelf);
      this.$axios.post(this.$mainUrl, this.UpdatePasswordBySelf).then(res=>{
        console.log('更改密码请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.updatePasswordDialogVisible = false;
          // this.alarmRuleList = res.data;
          this.$message({
            type:'success',
            message: '更改密码成功'
          })
        }else{
          this.$message({
            type:'error',
            message: '更改密码失败，' + res.data.error.message
          })
        }
      }).catch(error=>{
        this.$message({
          type:'error',
          message: error
        })
      })
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if(command == 'loginout'){
        localStorage.removeItem('ms_username')
        this.$router.push('/login');
      }
    },
    // 侧边栏折叠
    collapseChage(){
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
    // 全屏事件
    handleFullScreen(){
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    loginout(){
      this.Logout.token = this.$store.state.token;
      console.log('注销请求');
      this.$axios.post(this.$mainUrl, this.Logout).then(res=>{
        console.log('注销请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          localStorage.removeItem('token')
          this.$router.push('/');
        }else{
          this.$message({
            type:'error',
            message: '注销失败，' + res.data.error.message
          })
        }
      }).catch(error=>{
        this.$message({
          type:'error',
          message: error
        })
      })

    },
    gotoDataBaseBackup(){
      this.$router.push('/databaseBackup')
    }
  },
  mounted(){
    if(document.body.clientWidth < 1500){
      this.collapseChage();
    }
  }
}
</script>
<style scoped>
  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
  }
  .collapse-btn{
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
  }
  .header .logo{
    float: left;
    width:350px;
    line-height: 70px;
  }
  .header-right{
    float: right;
    padding-right: 50px;
  }
  .header-user-con{
    display: flex;
    height: 70px;
    align-items: center;
  }
  .btn-fullscreen{
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
  }
  .btn-bell, .btn-fullscreen{
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
  }
  .btn-bell-badge{
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
  }
  .btn-bell .el-icon-bell{
    color: #fff;
  }
  .user-name{
    margin-left: 10px;
  }
  .user-avator{
    margin-left: 20px;
  }
  .user-avator img{
    display: block;
    width:40px;
    height:40px;
    border-radius: 50%;
  }
  .el-dropdown-link{
    color: #fff;
    cursor: pointer;
  }
  .el-dropdown-menu__item{
    text-align: center;
  }
</style>
